<template>
  <div class="hero">
    <div class="hero__image">
      <img v-if="imgSrc" :src="imgSrc" class="hero__image__img" alt="" />
      <m4-icon v-else-if="icon" icon="user" class="hero__image__icon"></m4-icon>
      <div class="hero__image__badge" style="display: none;"></div>
    </div>
    <p v-if="personalId" class="hero__personal-id">
      {{ personalId }}
    </p>
    <h1 class="hero__title">{{ title }}</h1>
    <p class="hero__subtitle"><span v-html="subtitle"></span></p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "M4Hero",
  props: ["imgSrc", "personalId", "title", "subtitle", "icon"]
};
</script>
